import { render, staticRenderFns } from "./MasterUserStaff.vue?vue&type=template&id=28e537f1&"
import script from "./MasterUserStaff.vue?vue&type=script&lang=js&"
export * from "./MasterUserStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports